import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download, Zap } from 'lucide-react';
export function Urgency() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-green py-20 px-6 text-white text-center" data-id="element-462">
      <div className="max-w-3xl mx-auto" data-id="element-463">
        <FadeIn data-id="element-464">
          {/* Texto principal */}
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-465">
            ESTÁS A UN SOLO PASO DE EMPEZAR
          </h2>

          <p className="text-lg md:text-xl text-white/80 mb-4 leading-relaxed" data-id="element-466">
            Hoy puedes acceder a esta guía práctica y ver paso a paso cómo
            funciona todo desde dentro.
          </p>

          <div className="space-y-1 mb-10" data-id="element-467">
            <p className="text-lg md:text-xl text-white/90 font-medium" data-id="element-468">
              Sin experiencia.
            </p>
            <p className="text-lg md:text-xl text-white/90 font-medium" data-id="element-469">
              Sin complicaciones.
            </p>
            <p className="text-lg md:text-xl text-white/90 font-medium" data-id="element-470">
              Sin perder tiempo.
            </p>
          </div>

          <p className="text-xl md:text-2xl text-brand-gold font-semibold mb-12 flex items-center justify-center gap-3" data-id="element-471">
            <span data-id="element-472">👉</span> Solo necesitas empezar.
          </p>

          {/* Bloque de refuerzo */}
          <div className="bg-white/5 border border-brand-gold/30 rounded-xl p-6 mb-12" data-id="element-473">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-white/90 font-medium text-lg" data-id="element-474">
              <span data-id="element-475">✔️ Acceso inmediato</span>
              <span data-id="element-476">✔️ Método claro y fácil de seguir</span>
              <span data-id="element-477">✔️ Diseñado para empezar desde cero</span>
            </div>
          </div>

          {/* Urgencia */}
          <div className="mb-12" data-id="element-478">
            <p className="text-lg text-brand-gold font-bold mb-2" data-id="element-479">
              ⚠️ Este precio es de lanzamiento y puede cambiar en cualquier
              momento.
            </p>
            <p className="text-white/70 text-lg" data-id="element-480">
              Aprovecha ahora y empieza hoy mismo.
            </p>
          </div>

          {/* Botones */}
          <div className="flex flex-col items-center gap-4" data-id="element-481">
            <Button onClick={goToCheckout} className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold/90 text-brand-green shadow-brand-gold/20 text-lg px-10" data-id="element-482">
              QUIERO ACCEDER AHORA
            </Button>
            <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/sistema-completo-amazon-fba', '_blank')} className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white border border-white/30 text-lg px-10" data-id="element-483">
              SISTEMA COMPLETO AMAZON FBA
            </Button>
            <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/crea-tu-marca-en-amazon-desde-china', '_blank')} className="w-full sm:w-auto bg-white/10 hover:bg-white/20 text-white border border-white/30 text-lg px-10" data-id="element-484">
              CREA TU PROPIA MARCA
            </Button>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-white/50 text-xs mt-4" data-id="element-485">
              <span className="flex items-center gap-1.5" data-id="element-486">
                <Zap className="w-3.5 h-3.5 text-brand-gold" data-id="element-487" />
                ACCESO INMEDIATO
              </span>
              <span className="flex items-center gap-1.5" data-id="element-488">
                <Download className="w-3.5 h-3.5 text-brand-gold" data-id="element-489" />
                DESCARGA DIGITAL
              </span>
              <span className="flex items-center gap-1.5" data-id="element-490">
                <ShieldCheck className="w-3.5 h-3.5 text-brand-gold" data-id="element-491" />
                COMPRA SEGURA
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}